 //获取sessionStorage的值
 let getSession = (key) => {
  let res =JSON.parse(sessionStorage.getItem(key)) 
  if(!res){
    res = false;
  }

  return res;

}

//设置sessionStorage的值
let setSession = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify(value))
}

export default {getSession,setSession}